import React, { useContext, useState } from "react";
import { AppContext } from "../../misc/Context";
import { Dropdown, Layout, Menu, Modal } from "antd";
import styles from "./AdminLayout.module.less";
import { CHANNEL_CACHE, TOKEN_KEY } from "../../misc/Config";
import { ISlideMenu } from "../../misc/Interface";
import { Link, Switch, Route } from "react-router-dom";
import Loadable from "react-loadable";
import CustomSpin from "../../misc/CustomSpin";
import { LOGO } from "../../misc/Assist";
import {
    UserOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
    LogoutOutlined,
    ProfileOutlined,
    FormOutlined,
    ClockCircleOutlined,
    InfoCircleOutlined,
} from "@ant-design/icons";
import { isCidaPartnerAdmin } from "../../misc/Utils";

const { Header, Sider, Content } = Layout;
const SubMenu = Menu.SubMenu;


function loader(load: () => any) {
    return Loadable({
        loader: load,
        loading: CustomSpin,
        delay: 10,
    })
}

const Home = loader(() => import("../Home/Home"));
const User = loader(() => import("../User/User"));
const UserAdd = loader(() => import("../User/UserAdd"));
const UserBatchAdd = loader(() => import("../User/UserBatchAdd"));
const Cert = loader(() => import("../Cert/Cert"));
const Apply = loader(() => import("../Cert/Apply"));
const Material = loader(() => import("../Material/Material"));
const Payment = loader(() => import("../Payment"));
const ExamConfig = loader(() => import("../ExamConfig/ExamConfig"));
const Profile = loader(() => import("../Profile"));
const Inviter = loader(() => import("../Inviter"));

function AdminPages() {
    return <Switch>
        <Route exact path="/" component={ Home }/>
        <Route exact path="/user" component={ User }/>
        <Route exact path="/user-add" component={ UserAdd }/>
        <Route exact path="/user-batch-add" component={ UserBatchAdd }/>
        <Route exact path="/cert" component={ Cert }/>
        <Route exact path="/exam-config" component={ ExamConfig }/>
        <Route exact path="/apply" component={ Apply }/>
        <Route exact path="/material" component={ Material }/>
        <Route exact path="/payment" component={ Payment }/>
        <Route exact path="/profile" component={ Profile }/>
        <Route exact path="/inviter" component={ Inviter }/>
    </Switch>
}


const slideMenus: Array<ISlideMenu> = [
    {
        name: '考生管理',
        icon: <UserOutlined/>,
        key: 'user',
        route: "/user"
    },
    {
        name: '申请管理',
        icon: <FormOutlined/>,
        key: 'cert',
        route: "/cert"
    },
    {
        name: '备考材料',
        icon: <ProfileOutlined/>,
        key: 'material',
        route: "/material"
    },
    {
        name: '考试时间',
        icon: <ClockCircleOutlined/>,
        key: 'exam-config',
        route: "/exam-config"
    },
    {
        name: '机构信息',
        icon: <InfoCircleOutlined/>,
        key: 'profile',
        items: [
            {
                name: '基本信息',
                key: 'profile',
                route: "/profile",
            },
            {
                name: '业务员管理',
                key: 'profile-inviter',
                route: "/inviter",
            },
        ]
    },
];


function AdminMenu(props: { collapsed: boolean }) {

    function SubmenuOrMenuItem(menu: ISlideMenu) {
        return menu.items ? <SubMenu
            key={ menu.key }
            title={ <span>{ menu.icon }<span>{ menu.name }</span></span> }
        >
            { menu.items.map(_ => SubmenuOrMenuItem(_)) }
        </SubMenu> : <Menu.Item key={ menu.key }>
            { menu.route && <Link to={ menu.route }>
                { menu.icon && menu.icon }
                <span>{ menu.name }</span>
            </Link> }
        </Menu.Item>
    }

    return <Menu
        mode="inline"
        theme="dark"
        inlineCollapsed={ props.collapsed }
    >
        { slideMenus.map(menu => SubmenuOrMenuItem(menu)) }
    </Menu>
}

function AdminBreadcrumb() {
    const ctx = useContext(AppContext);
    return <div>{ ctx.breadcrumb }</div>
}

export default function () {
    const [collapsed, setCollapsed] = useState<boolean>(false);
    const context = useContext(AppContext);

    function logout() {
        Modal.confirm({
            title: '确定退出登录?',
            onOk: () => {
                localStorage.removeItem(TOKEN_KEY);
                localStorage.removeItem(CHANNEL_CACHE);
                window.location.href = "/login";
            }
        })
    }

    return <Layout style={ { minHeight: "100%" } }>
        <Sider
            trigger={ null }
            collapsible
            collapsed={ collapsed }
            className={ styles.SlideMenuLayout }
        >
            <div className={ styles.LogoWrapper }>
                <img src={ isCidaPartnerAdmin() ? "https://cdn.cecctm.com/news/cida_favicon.ico" : LOGO } alt="" className={ styles.Logo }/>
                { !collapsed && <div className={ styles.LogoText }>机构后台</div> }
            </div>
            <AdminMenu collapsed={ collapsed }/>
        </Sider>
        <Layout>
            <Header className={ styles.Header }>
                <div className={ styles.BreadcrumbWrapper }>
                    { collapsed ?
                        <MenuUnfoldOutlined
                            className={ styles.TriggerIcon }
                            onClick={ () => setCollapsed(!collapsed) }
                        /> :
                        <MenuFoldOutlined
                            className={ styles.TriggerIcon }
                            onClick={ () => setCollapsed(!collapsed) }
                        />
                    }
                    <AdminBreadcrumb/>
                </div>
                <div className={ styles.HeaderRightWrapper }>
                    <Dropdown overlay={
                        <Menu>
                            <Menu.Item onClick={ logout }>
                                <LogoutOutlined/> 退出登录
                            </Menu.Item>
                        </Menu>
                    }>
                        <div className={ styles.CurrentAdminName }>{ context.admin.realname }</div>
                    </Dropdown>
                </div>
            </Header>
            <Content style={ { margin: '24px 16px', padding: 24, background: '#fff', minHeight: 280 } }>
                <AdminPages/>
            </Content>
        </Layout>
    </Layout>
}





